module.exports = __webpack_public_path__ + "static/media/ic_checkmark.68c48943.png";